import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap';
import { BiHome, BiLogOutCircle, BiMenu, BiMoneyWithdraw } from 'react-icons/bi';
import { BsArrowLeftSquareFill } from 'react-icons/bs';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../../../Redux/Slice/Auth/authSlice';
import { useDispatch } from 'react-redux';
import { ImUsers } from 'react-icons/im';
import { FaFirstOrder, FaMoneyBill } from 'react-icons/fa';
import { MdConnectWithoutContact } from 'react-icons/md';
import { RiDashboardFill } from 'react-icons/ri';
import { IoNewspaperSharp } from 'react-icons/io5';
import { IoSettings } from "react-icons/io5";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CgPerformance } from 'react-icons/cg';
import { IoIosNotifications } from 'react-icons/io';
import { BiBell } from "react-icons/bi";
import { headerNotification } from '../../../Services/AdminServices/AdminCommissionServices';

const Sidebar = () => {

    const [notifications, setNotifications] = useState([])

    const location = useLocation()
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
    });

    const renderTooltip = (title) => (props) => (
        <Tooltip id="custom-tooltip" {...props} className="">
            {title}
        </Tooltip>
    );

    const handleLogout = async () => {
        dispatch(logout());
        navigate('/')
    }

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [onHover, setOnHover] = useState(false);
    const [toggle, setToggle] = useState(false);


    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [])


    const getNotification = async () => {
        const response = await headerNotification();
        if (response?.code === 200) {
            setNotifications(response?.result?.unapprovedPayments)
        }
    }

    useEffect(() => {
        getNotification();
    }, []);



    useEffect(() => {
        if (screenSize.width <= 1024) {
            setToggle(false);
        }
    }, [location.pathname]);


    return (
        <>
            <div
                className={`wrapper ${toggle ? "toggled" : ""} ${onHover ? "sidebar-hovered" : ""
                    }`}
            >
                {/*sidebar wrapper */}
                <div
                    className="sidebar-wrapper"
                    data-simplebar="true"
                // onMouseEnter={() => setOnHover(true)}
                // onMouseLeave={() => setOnHover(false)}
                >
                    <div className="sidebar-header">
                        {/* <div>
                            <img
                                src={logo}
                                className="logo-icon"
                                alt="logo icon"
                            />
                        </div> */}
                        <div>
                            <Link to="/admin" className="text-decoration-none">
                                <div>
                                    <h4 className="logo-text">Popgop</h4>
                                </div>
                            </Link>

                        </div>
                        <div
                            className="toggle-icon ms-auto mob-toggle"
                            onClick={() => setToggle(!toggle)}
                        >
                            <BsArrowLeftSquareFill />
                        </div>
                    </div>
                    {/*navigation*/}
                    <ul className="metismenu mm-show" id="menu">
                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Dashboard")}>
                                <Link
                                    to="/admin"
                                    className={`${location?.pathname === "/admin" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <RiDashboardFill />
                                    </div>
                                    <div className="menu-title">Dashboard</div>
                                </Link>
                            </OverlayTrigger>
                        </li>

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Withdrawal")}>
                                <Link
                                    to="/admin/withdrawal"
                                    className={`${location?.pathname === "/admin/withdrawal" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <BiMoneyWithdraw />
                                    </div>
                                    <div className="menu-title">Withdrawal</div>
                                </Link>
                            </OverlayTrigger>
                        </li>

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Users")}>
                                <Link
                                    to="/admin/users"
                                    className={`${location?.pathname === "/admin/users" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <ImUsers />
                                    </div>
                                    <div className="menu-title">Users</div>
                                </Link>
                            </OverlayTrigger>
                        </li>
                        {/* <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Coupons")}>
                                <Link
                                    to="/admin/coupons"
                                    className={`${location?.pathname === "/admin/coupons" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="coupons-icon d-flex">
                                        <ImUsers />
                                    </div>
                                    <div className="menu-title">Coupons</div>
                                </Link>
                            </OverlayTrigger>
                        </li> */}

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Referal Orders")}>
                                <Link
                                    to="/admin/orders"
                                    className={`${location?.pathname === "/admin/orders" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <FaFirstOrder />
                                    </div>
                                    <div className="menu-title">Referal Orders</div>
                                </Link>
                            </OverlayTrigger>
                        </li>

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Newsletters")}>
                                <Link
                                    to="/admin/newsletters"
                                    className={`${location?.pathname === "/admin/newsletters" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <IoNewspaperSharp />
                                    </div>
                                    <div className="menu-title">Newsletters</div>
                                </Link>
                            </OverlayTrigger>
                        </li>

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Refferal User Sale")}>
                                <Link
                                    to="/admin/refferal-user-sale"
                                    className={`${location?.pathname === "/admin/refferal-user-sale" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <CgPerformance />
                                    </div>
                                    <div className="menu-title"> Refferal User Sale</div>
                                </Link>
                            </OverlayTrigger>
                        </li>

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Notifications")}>
                                <Link
                                    to="/admin/notifications"
                                    className={`${location?.pathname === "/admin/notifications" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <IoIosNotifications />

                                    </div>
                                    <div className="menu-title">User Notification</div>
                                </Link>
                            </OverlayTrigger>
                        </li>

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Voucher")}>
                                <Link
                                    to="/admin/vouchers"
                                    className={`${location?.pathname === "/admin/voucher" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <FaMoneyBill />
                                    </div>
                                    <div className="menu-title">Vouchers</div>
                                </Link>
                            </OverlayTrigger>
                        </li>


                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Settings")}>
                                <Link
                                    to="/admin/settings"
                                    className={`${location?.pathname === "/admin/settings" ? "sidebarItem-active text-decoration-none" : "text-decoration-none"}`}
                                >
                                    <div className="parent-icon d-flex">
                                        <IoSettings />
                                    </div>
                                    <div className="menu-title">Settings</div>
                                </Link>
                            </OverlayTrigger>
                        </li>

                        <li>
                            <OverlayTrigger placement="right" overlay={renderTooltip("Logout")}>
                                <div onClick={handleLogout}>
                                    <Link className="text-decoration-none">
                                        <div className="parent-icon d-flex">
                                            <BiLogOutCircle />
                                        </div>
                                        <div className="menu-title">Logout</div>
                                    </Link>
                                </div>
                            </OverlayTrigger>
                        </li>
                    </ul>
                    {/*end navigation*/}
                </div>

                <header>
                    <div className="topbar d-flex align-items-center">
                        <nav className="navbar navbar-expand">
                            <div className="" onClick={() => setToggle(!toggle)}>
                                <BiMenu size={26} />
                            </div>

                            <div className="top-menu ms-auto">
                                <ul className="navbar-nav align-items-center gap-3">
                                    {/* 🔔 Notification Dropdown */}
                                    <Dropdown align="end">
                                        <Dropdown.Toggle
                                            className="bg py-1 px-1 bg-transparent border-0  text-dark p-0"
                                            id="dropdown-notification"
                                        >
                                            <BiBell size={26} />
                                            {notifications.length > 0 && (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: "2px",
                                                        right: "2px",
                                                        background: "red",
                                                        color: "white",
                                                        fontSize: "10px",
                                                        borderRadius: "50%",
                                                        padding: "2px 5px",
                                                    }}
                                                >
                                                    {notifications.length}
                                                </span>
                                            )}
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu style={{ width: "380px" }}>
                                            <Dropdown.Header className='border-bottom'>Notifications</Dropdown.Header>
                                            {notifications.length > 0 ? (
                                                notifications.map((n) => (
                                                    <Dropdown.Item
                                                        as={Link}
                                                        to={"/admin/withdrawal"}
                                                        key={n.id}
                                                        className="d-flex border-bottom justify-content-between align-items-start"
                                                    >
                                                        <div className=''>
                                                            <div>{n.user?.email}</div>
                                                            <small className="text-muted">{n.created_at}</small>
                                                        </div>

                                                        <div>
                                                            <p className='mb-0'>
                                                                <small className="text-muted">PKR</small>
                                                            </p>
                                                            <p className='mb-0'>
                                                                <small className="text-muted">{n.amount}</small>
                                                            </p>
                                                        </div>
                                                    </Dropdown.Item>
                                                ))
                                            ) : (
                                                <Dropdown.Item>No notifications</Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    {/* 👤 User Dropdown */}
                                    <Dropdown>
                                        <Dropdown.Toggle className="bg bg-transparent border-0 text-dark">
                                            admin
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </header>

                <div className="page-wrapper">
                    <div className="page-content">
                        <Outlet />
                    </div>
                </div>

                <div className="overlay toggle-icon"></div>

                {/* <footer className="page-footer">
          <p className="mb-0">Copyright © 2023. All right reserved.</p>
        </footer> */}
            </div >
        </>
    )
}

export default Sidebar